import { MESSAGES_SERVICE } from "@/services/messages.service.js";
import router from '@/router/index';

const state = { listOutput: {}, addMessageProgress: undefined, removeMessagesProgress: undefined };

const actions = {
    getList({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        MESSAGES_SERVICE.list()
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    addMessage({ dispatch, commit }, inputMessage) {
        dispatch('alert/clear', null, { root: true });
        commit('addRequest');

        MESSAGES_SERVICE.add(inputMessage.text, inputMessage.userId)
            .then(
                output => {
                    commit('addSuccess', output);
                },
                error => {
                    commit('addFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    removeMessages({ dispatch, commit }, messageIds) {
        dispatch('alert/clear', null, { root: true });
        commit('removeRequest');

        MESSAGES_SERVICE.remove(messageIds)
            .then(
                output => {
                    commit('removeSuccess');
                },
                error => {
                    commit('removeFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        //
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = {};
    },
    /* Add */
    addRequest(state) {
        state.addMessageProgress = undefined;
    },
    addSuccess(state) {
        state.addMessageProgress = true;
    },
    addFailure(state) {
        state.addMessageProgress = false;
    },
    /* Remove */
    removeRequest(state) {
        state.removeMessagesProgress = undefined;
    },
    removeSuccess(state) {
        state.removeMessagesProgress = true;
    },
    removeFailure(state) {
        state.removeMessagesProgress = false;
    },
};

export const messages = {
    namespaced: true,
    state,
    actions,
    mutations
};
